import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'portfolioImbalancesView'
})
export class PortfolioImbalancesViewPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
